/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Switch_LanguageInputs */

const en_footer_switch_language = /** @type {(inputs: Footer_Switch_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch Language:`)
};

const es_footer_switch_language = /** @type {(inputs: Footer_Switch_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar el Lenguaje:`)
};

/**
* | output |
* | --- |
* | "Switch Language:" |
*
* @param {Footer_Switch_LanguageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
const footer_switch_language = /** @type {((inputs?: Footer_Switch_LanguageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Switch_LanguageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_switch_language(inputs)
	return en_footer_switch_language(inputs)
});
export { footer_switch_language as "footer.switch_language" }